import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import { getFiltersByKeysWithValues } from '@framework/ui/Organisms/Filters/helpers';
import FiltersBtn from '@/creditflowresearch/ui/common/components/organisms/FiltersBtn';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const filtersKeys = [
  'includedStatus',
  'includedSubsectorIds',
  'includedIssuerIds',
  'includedDealerIds',
  'currentFaceRange',
  'currentFaceRangeIds',
  'walRange',
  'includedRatingGroupIds',
  'includedRatingAgencyIds',
  'includedBenchmarkGroupIds',
  'spreadRange',
  'includedSpeedTypeIds',
  'speedRange',
  'dates',
];

interface IFiltersBtnContainerProps {
  onClick: () => void,
  className?: string,
}

const FiltersBtnContainer = ({ onClick, className }: IFiltersBtnContainerProps) => {
  const { getFilters } = useFiltersContext();
  const filtersState = getFilters(BONDS_STORE_NAME);
  const { dateFromMin } = useBondsFiltersContext();

  return (
    <FiltersBtn
      filtersCount={ Object.keys(getFiltersByKeysWithValues({ filtersState, filtersKeys, dateFromMin })).length }
      onClick={ onClick }
      className={ className }
    />
  );
};

export default FiltersBtnContainer;
